import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights = null;
const dontTrackUrls = [
  'signalr',
  'zendesk',
  'zdassets',
  'amazonaws',
  'well-known',
  'getbeamer',
  'sockjs-node',
  'userflow',
  'google-analytics',
  'maps.googleapis',
  '.tpl.html',
  'ps/api/event',
];

const doNothing = () => {};
const fallback = {
  trackEvent: doNothing,
  trackPageView: doNothing,
  trackPageViewPerformance: doNothing,
  trackException: doNothing,
  trackTrace: doNothing,
  trackMetric: doNothing,
  startTrackPage: doNothing,
  stopTrackPage: doNothing,
  startTrackEvent: doNothing,
  stopTrackEvent: doNothing,
};
const getter = () => appInsights || fallback;
/**
   React usage:
   import appInsights from '@/appInsights';
   appInsights().trackEvent({name:"EventName"});
 */
export default getter;

export const initAppInsights = (key, user) => {
  const { GroupSid: tenantId, Sid: userId } = user.profile;

  if (!key) {
    appInsights = null;
    return appInsights;
  }

  if (appInsights) {
    console.warn('AppInsights already initialized');
    return appInsights;
  }
  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: key,
    },
  });

  appInsights.loadAppInsights();
  appInsights.addTelemetryInitializer(envelope => {
    if (envelope.baseType === 'EventData') return true; // trackEvent
    const prohibitedUrlFound = dontTrackUrls.some(url => envelope.baseData.target.includes(url));
    if (prohibitedUrlFound) return false;

    envelope.data.tenant = tenantId;
    envelope.data.user = userId;
    envelope.data.pageUrl = window.location.href;

    return true;
  });
  return appInsights;
};
